import { render, staticRenderFns } from "./editCube6.vue?vue&type=template&id=b61f6306&scoped=true&"
import script from "./editCube6.vue?vue&type=script&lang=js&"
export * from "./editCube6.vue?vue&type=script&lang=js&"
import style0 from "./editCube6.vue?vue&type=style&index=0&id=b61f6306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61f6306",
  null
  
)

export default component.exports